import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/App.css';
import { HashRouter, Route, Routes, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/home';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/theme';
import { QueryClientProvider, QueryClient } from 'react-query';
import AuthProvider from './contexts/AuthProvider'
import { PrivateRoute, DefaultRoute } from './contexts/AuthProvider';
import { PermissionProtectedRoute } from 'components/auth/ProtectedRoute';
import { AUTH_PERMISSIONS } from 'config/authRegistry';
import DeviationCategoriesAdmin from 'views/admin/deviationCategories';
import SignIn from 'views/auth/signIn';
import ResetPassword from 'views/auth/forgotPassword';
import LiveSimulator from 'views/admin/simulator';
import ForecastAdmin from 'views/admin/forecast';
import { SimulatorPremisesDrawerProvider } from 'contexts/SimulatorPremisesDrawerContext';
import Dashboards from 'views/admin/dashboardElements';
import DashboardTabManager from 'views/admin/dashboardView';
import UserManager from 'views/admin/users';
import MastersSection from 'views/admin/masters/MastersSection';

const qc = new QueryClient()

ReactDOM.render(
	<HashRouter>
		<AuthProvider>
			<QueryClientProvider client={qc}>
				<ChakraProvider theme={theme}>
					<React.StrictMode>
						<Routes>
							<Route path={`/auth/sign-in`} element={<AuthLayout><SignIn /></AuthLayout>} />
							<Route path={`/auth/forgot-password`} element={<AuthLayout><ResetPassword /></AuthLayout>} />
							<Route path={`/auth/*`} element={<Navigate to="/auth/sign-in" />} />
							<Route element={<PrivateRoute />}>
								<Route path={`/dashboards/elements`} element={<AdminLayout title="Tableros" footer={false} renderSidebar={true}><Dashboards /></AdminLayout>} />
								<Route path={`/dashboards/view`} element={<AdminLayout title="Visualizar Tableros" footer={false} backButtonTo={'/dashboards/elements'}><DashboardTabManager /></AdminLayout>} />
							</Route>
							<Route element={<PrivateRoute />}>
								<Route path={`/coverage/parameters`} element={<Navigate to="/coverage/simulator" replace />} />
								<Route
									path={`/coverage/forecast`}
									element={
										<AdminLayout title="Forecast" footer={false} renderSidebar={true}>
											<ForecastAdmin />
										</AdminLayout>
									}
								/>
								<Route path={`/coverage/simulator`} element={
									<SimulatorPremisesDrawerProvider>
										<AdminLayout title="Simulador de Cobertura" footer={false}>
											<LiveSimulator />
										</AdminLayout>
									</SimulatorPremisesDrawerProvider>
								} />
							</Route>
							<Route element={<PrivateRoute />}>
								<Route
									element={
										<PermissionProtectedRoute
											permission={AUTH_PERMISSIONS.DEVIATION_CATEGORIES_MANAGE}
										/>
									}
								>
									<Route
										path={`/coverage/deviation-categories`}
										element={
											<AdminLayout title="Categorías de desviaciones" footer={false} renderSidebar={true}>
												<DeviationCategoriesAdmin />
											</AdminLayout>
										}
									/>
								</Route>
							</Route>
							<Route element={<PrivateRoute />}>
								<Route path={`/users/manage`} element={<AdminLayout title="Usuarios y Grupos" footer={false} renderSidebar={true}><UserManager /></AdminLayout>} />
							</Route>
							<Route element={<PrivateRoute />}>
								<Route
									path={`/masters/products`}
									element={
										<AdminLayout title="Productos" footer={false} renderSidebar={true}>
											<MastersSection />
										</AdminLayout>
									}
								/>
								{/* <Route
									path={`/masters/suppliers`}
									element={
										<AdminLayout title="Proveedores" footer={false} renderSidebar={true}>
											<MastersSection />
										</AdminLayout>
									}
								/> */}
							</Route>
							<Route path={'/*'} element={<DefaultRoute />} />
						</Routes>
					</React.StrictMode>
				</ChakraProvider>
			</QueryClientProvider>
		</AuthProvider>
	</HashRouter>,
	document.getElementById('root')
);
